const SECTION_ANCHOR_SELECTOR = [
  ".sc-section-inner",
  ".sc-featured-product-inner",
  ".sc-sticky-content-inner"
].join(", ");
function getSectionAnchorTarget(hash) {
  if (!hash || hash === "#") return null;
  try {
    const id = decodeURIComponent(hash.slice(1));
    const target = document.getElementById(id);
    return (target == null ? void 0 : target.matches(SECTION_ANCHOR_SELECTOR)) ? target : null;
  } catch {
    return null;
  }
}
function closeMobileNavigation() {
  document.querySelectorAll("header-v3-component.is-open").forEach((header) => {
    var _a;
    return (_a = header.closeMobileNav) == null ? void 0 : _a.call(header);
  });
}
function getScrollMarginTop(target) {
  return Number.parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
}
function scrollToSection(target) {
  var _a, _b;
  const reduceMotion = ((_a = document.body) == null ? void 0 : _a.dataset.reduceMotion) === "true" || window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const lenis = (_b = window.Theme) == null ? void 0 : _b.lenis;
  if (lenis && !reduceMotion) {
    lenis.scrollTo(target, { offset: -getScrollMarginTop(target) });
    return;
  }
  target.scrollIntoView({
    behavior: reduceMotion ? "auto" : "smooth",
    block: "start"
  });
}
function handleSectionAnchorClick(event) {
  var _a, _b;
  if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)
    return;
  const anchor = (_b = (_a = event.target) == null ? void 0 : _a.closest) == null ? void 0 : _b.call(_a, "a[href]");
  if (!anchor || anchor.hasAttribute("download") || anchor.target && anchor.target.toLowerCase() !== "_self")
    return;
  let url;
  try {
    url = new URL(anchor.getAttribute("href"), window.location.href);
  } catch {
    return;
  }
  const isCurrentPage = url.origin === window.location.origin && url.pathname === window.location.pathname && url.search === window.location.search;
  if (!isCurrentPage) return;
  const target = getSectionAnchorTarget(url.hash);
  if (!target) return;
  event.preventDefault();
  closeMobileNavigation();
  if (window.location.hash !== url.hash) {
    window.history.pushState(null, "", url.href);
  }
  requestAnimationFrame(() => {
    if (target.isConnected) scrollToSection(target);
  });
}
document.addEventListener("click", handleSectionAnchorClick);
